import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { MenuItem, styled } from "@mui/material";

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: 310,
            width: 200,
            fontSize: { xs: 12, lg: 14 }
        },
    },
};

const StyledInputLabel = styled(InputLabel)(({ theme }) => ({
    color: theme.palette.V080,     // Color por defecto
    "&.Mui-focused": {
        color: theme.palette.V090, // Color cuando el label está enfocado
    },
}));

// Estilo personalizado para el Select
const StyledSelect = styled(Select)(({ theme }) => ({
    // Fondo blanco para el contenedor principal
    backgroundColor: "white",

    // Aplica el color del borde por defecto
    "& .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.V050,
    },

    // Aplica el color del borde en hover
    "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.V090,
    },

    // Aplica el color del borde en focus
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.V090,
    },

}));


export default function BaseSelect(props) {
    const { children, id, value, onChange, values, label, error, type, disabled, hasTooltip, language, name, required, idName, valueName, shrink, ...rest } = props;

    return (
        <FormControl fullWidth error={error} disabled={disabled} required={required}>
            <StyledInputLabel id={"customized-base-select-label" + id} shrink={shrink} sx={{ fontSize: { xs: 12, lg: 14 }, height: 48 }}>
                {label}
            </StyledInputLabel>
            <StyledSelect
                {...rest}
                labelId={"customized-base-select-label" + id}
                id={"customized-base-select" + id}
                value={value}
                onChange={onChange}
                name={name}
                MenuProps={MenuProps}
                label={label}
                variant="outlined" // Asegúrate de usar la variante "outlined"
                sx={{ fontSize: { xs: 12, lg: 14 } }}
            >
                {children ? children : 
                    values.map((item) => (
                        <MenuItem key={item[valueName] + "_" + item[idName]} value={item[idName]} sx={{display: item[idName] === "hidden" ? "none" : "block" }}>
                                {item[valueName]}
                        </MenuItem>
                    ))
                }
            </StyledSelect>
        </FormControl>
    );
}
